<!-- Header -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <div class="col-6 col-lg-3 col-md-6 col-sm-8">
      <div class="d-flex">
        <!-- Search  -->
        <div class="input-group">
          <input class="form-control" type="text" name="searchTerm"
            placeholder="{{ 'lblSearchByNameandSubject' | translate }}" [(ngModel)]="requestModal.searchTerm"
            autocomplete="off" (keyup.enter)="onSearch()" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary" (click)="onSearch()">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Template Button -->
    <div class="col-auto ml-auto">
      <button type="button" type="reset" aria-label="Center Align" *ngIf="userRoleRightsDetails.canAdd"
        class="ml-3 add-button btn btn-primary" (click)="onEdit('add', '')" translate>
        lblAddTemplate
      </button>
    </div>
  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card">
        <!-- Title -->
        <div class="card-header d-flex justify-content-between">
          <h4 class="card-title" translate>lblCampaignTemplate</h4>
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <div class="table-responsive max-h200" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th scope="col" style="width: 55px">#</th>
                <th scope="col" sortable="Name" (sort)="onSort($event)" translate>
                  lblName
                </th>
                <th scope="col" sortable="Subject" (sort)="onSort($event)" translate>
                  lblSubject
                </th>
                <th scope="col" sortable="Channel" (sort)="onSort($event)" translate>
                  lblChannel
                </th>
                <th scope="col" sortable="CreatedBy" (sort)="onSort($event)" translate>
                  lblCreatedBy
                </th>
                <th scope="col" sortable="CreatedDate" (sort)="onSort($event)" translate>
                  lblCreatedDate
                </th>
                <th scope="col" sortable="UpdatedBy" (sort)="onSort($event)" translate>
                  lblUpdatedBy
                </th>
                <th scope="col" sortable="UpdatedDate" (sort)="onSort($event)" translate>
                  lblUpdatedDate
                </th>
                <th class="text-center" style="width: 120px" scope="col" translate>
                  lblAction
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="templateList?.length > 0; else load_else">
                <tr *ngFor="let item of templateList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.subject }}</td>
                  <td>{{ channel[item.channel] }}</td>
                  <td>{{ item.createdBy }}</td>
                  <td>{{ item.createdDate + "Z" | date : "short" }}</td>
                  <td>{{ item.updatedBy }}</td>
                  <td>{{ item.updatedDate + "Z" | date : "short" }}</td>
                  <td class="text-center nowrap">
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblView' | translate }}"
                      *ngIf="userRoleRightsDetails.canView" (click)="onEdit('view', item.id)">
                      <em class="fas fa-eye fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canEdit"></span>
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblEdit' | translate }}"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit('edit', item.id)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblDelete' | translate }}"
                      *ngIf="userRoleRightsDetails.canDelete" (click)="onDelete(item.id)" tooltipClass="custom-revert">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="12" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>